import React from "react";

import "../css/slider.css";
import {Slide} from "react-slideshow-image";

function Slider({ images }) {
    return (
        <Slide canSwipe={false} arrows={false} transitionDuration={500} pauseOnHover={false} autoplay={true}>
            {images.map((item, index) => {
                return (
                    <div
                        key={`slider.${index}`}
                        style={{backgroundImage: `url("${item.src}")`}}
                     />
                );
            })}
        </Slide>
    );
}

export default Slider;
